import React from 'react';
import { volumes } from '../data/content';
export function Volumes() {
  return <section aria-labelledby="volumenes-title" className="w-full bg-cream-50 px-5 py-20 sm:py-24" data-id="element-165" data-mp="1lv0auyvyebs6">
      <div className="mx-auto max-w-content" data-id="element-166" data-mp="18458m5fymsxk">
        <div className="text-center sm:text-left" data-id="element-167" data-mp="185gdk8l566q9">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500" data-id="element-168" data-mp="1c579srtftf26">
            El método
          </p>
          <h2 id="volumenes-title" className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-5xl" data-id="element-169" data-mp="1zw4d5g76341t">
            Los 6 Volúmenes
          </h2>
        </div>

        <div className="mt-12 divide-y divide-cream-300 border-y border-cream-300" data-id="element-170" data-mp="1qu3dkcogo5wz">
          {volumes.map((volume, index) => <article key={volume.number} className="grid gap-4 py-8 sm:grid-cols-[6rem_minmax(0,1fr)] sm:gap-8" data-id="element-171" data-mp="ffhj1xo6hhe7" data-mpi={index}>
              <p aria-hidden="true" className="font-display text-5xl font-semibold leading-none text-rose-200" data-id="element-172" data-mp="kfvs9j1imxdt">
                {String(index + 1).padStart(2, '0')}
              </p>
              <div data-id="element-173" data-mp="3jbg8nvg3f8qc">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-plum-400" data-id="element-174" data-mp="20oslqo3zm8z">
                  {volume.number}
                </p>
                <h3 className="mt-2 font-display text-3xl font-semibold text-plum-800" data-id="element-175" data-mp="3t5ydx515rcc9">
                  {volume.title}
                </h3>
                <p className="mt-3 max-w-3xl text-base leading-relaxed text-plum-500" data-id="element-176" data-mp="62tlgn6qgeuk">
                  {volume.text}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}